export var buildEnv = {
  sdkVersion: '2.1.5',
  sdkName: 'df_web_rum_sdk'
};